import ReviewForm from "../component/ReviewForm";
const AddReview = () => { return (<ReviewForm />) }
export default AddReview;